import { useIntl } from "react-intl";

import type { DataTableColumn } from "~components/DataTable/types/dataTableColumn.ts";
import { VenueTableColumns } from "~pages/Venues/VenueListPage/enums/venueTableColumns.ts";
import type { Venue } from "~types/venue.ts";

export const useGetVenueTableColumns = (): Array<DataTableColumn<Venue>> => {
  const { formatMessage } = useIntl();

  return [
    {
      key: VenueTableColumns.NameLocal,
      title: formatMessage({ id: "name.local.full" }),
      dataIndex: "nameLocal",
      width: 240,
      ellipsis: { showTitle: true },
      sorter: true,
    },
    {
      key: VenueTableColumns.VenueId,
      title: formatMessage({ id: "venue.id" }),
      dataIndex: "venueId",
      copyable: false,
      width: 220,
    },
    {
      key: VenueTableColumns.TimeZone,
      title: formatMessage({ id: "timezone" }),
      dataIndex: "timezone",
      width: 140,
    },
    {
      key: VenueTableColumns.CountryCode,
      title: formatMessage({ id: "country" }),
      dataIndex: "countryCode",
      width: 140,
      render: (value: string | null | undefined) => (value ? formatMessage({ id: `countryCode.${value}` }) : ""),
    },
    {
      key: VenueTableColumns.Status,
      title: formatMessage({ id: "status" }),
      dataIndex: "status",
      width: 120,
      render: (value: string | null | undefined) => (value ? formatMessage({ id: value, defaultMessage: value }) : ""),
    },
    {
      key: VenueTableColumns.Capacity,
      title: formatMessage({ id: "capacity" }),
      dataIndex: "capacity",
      width: 120,
    },
    {
      key: VenueTableColumns.NameLatin,
      title: formatMessage({ id: "name.latin.full" }),
      dataIndex: "nameLatin",
      width: 240,
      ellipsis: { showTitle: true },
      sorter: true,
    },
    {
      key: VenueTableColumns.AbbreviationLocal,
      title: formatMessage({ id: "name.local.abbreviation" }),
      dataIndex: "abbreviationLocal",
      width: 160,
    },
    {
      key: VenueTableColumns.AbbreviationLatin,
      title: formatMessage({ id: "name.latin.abbreviation" }),
      dataIndex: "abbreviationLatin",
      width: 160,
    },
    {
      key: VenueTableColumns.ExternalId,
      title: formatMessage({ id: "externalId" }),
      dataIndex: "externalId",
      copyable: false,
      width: 220,
    },
  ];
};
